import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ReportSummary } from '@/pages/reports/ReportsPage/types';
import ReportTypeBadge from './ReportTypeBadge';

interface Props { reports: ReportSummary[]; detailHref: (type: string, id: string) => string }

const ReportFeedTable: React.FC<Props> = ({ reports, detailHref }) => {
  const navigate = useNavigate();

  return (
    <table className="min-w-full divide-y divide-gray-200 rounded-xl bg-white shadow-sm ring-1 ring-gray-200 dark:divide-gray-800 dark:bg-gray-900 dark:ring-gray-800">
      <caption className="sr-only">Reports</caption>
      <thead><tr>{['Date', 'Type', 'Player', 'Author', 'Rating or status', 'Attachments'].map(label => <th key={label} scope="col" className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">{label}</th>)}</tr></thead>
      <tbody className="divide-y divide-gray-200 dark:divide-gray-800">{reports.map(report => {
        const href = detailHref(report.type, report.id);

        return <tr
          key={`${report.type}-${report.id}`}
          className="cursor-pointer transition-colors hover:bg-gray-50 focus-within:bg-blue-50 dark:hover:bg-gray-800 dark:focus-within:bg-gray-800"
          onClick={event => {
            if (event.defaultPrevented || event.button !== 0 || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
            navigate(href);
          }}
        >
          <td className="whitespace-nowrap px-4 py-3 text-sm">
            <Link
              aria-label={`View ${report.type} report for ${report.player.name}`}
              className="font-semibold text-club-blue-700 outline-none hover:underline focus-visible:ring-2 focus-visible:ring-club-blue-500 dark:text-club-blue-300"
              to={href}
              onClick={event => event.stopPropagation()}
              onKeyDown={event => {
                if (event.key !== ' ') return;
                event.preventDefault();
                event.currentTarget.click();
              }}
            >
              {new Date(report.date).toLocaleDateString()}
            </Link>
          </td>
          <td className="px-4 py-3 text-sm"><ReportTypeBadge type={report.type} /></td>
          <td className="px-4 py-3 text-sm"><Link className="font-semibold text-club-blue-700 hover:underline dark:text-club-blue-300" to={`/players/${report.player.id}`} onClick={event => event.stopPropagation()}>{report.player.name}</Link></td>
          <td className="px-4 py-3 text-sm">{report.author.name}</td>
          <td className="px-4 py-3 text-sm">{report.rating ?? (report.medicalStatus || 'Not recorded')}</td>
          <td className="px-4 py-3 text-sm">{report.attachmentCount}</td>
        </tr>;
      })}</tbody>
    </table>
  );
};

export default ReportFeedTable;
